export interface ClarityConfig {
  enabled: boolean;
  projectId: string | undefined;
}

export const clarityConfig: Record<string, ClarityConfig> = {
  development: {
    enabled: false,
    projectId: process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID,
  },
  production: {
    enabled: true,
    projectId: process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID,
  },
  test: {
    enabled: false,
    projectId: undefined,
  },
};

export const getCurrentClarityConfig = (): ClarityConfig => {
  const env = process.env.NODE_ENV || "development";
  return clarityConfig[env] || clarityConfig.development;
};

export const isClarityEnabled = (): boolean => {
  const config = getCurrentClarityConfig();
  return config.enabled && Boolean(config.projectId);
};
